module.exports = __webpack_public_path__ + "b65e17b358d4c8e21acd12c2ec97100d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/msh.png
// module id = 271
// module chunks = 1